import styles from "./appLoader.module.css";

// Neutral full-screen fallback for screens outside the dashboard shell (login, public pages).
export default function AppLoader({ label = "Loading…" }) {
  return (
    <div className={styles.loader} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      <span className={styles.srOnly}>{label}</span>
    </div>
  );
}
